import { React, useState, useEffect, useContext } from 'react';
import * as api from "../api/apiConnector";
import waiting from "../assets/images/waiting.svg";
import * as utils from "../components/utils.js"


function ActivityUserLink({ voc,
    selected,
    multiple,
    value = "Id",
    text = "Name",
    textDelegate,
    onChange,
    dropDownParent,
    allowClear = true,
    placeholder = "<-- Select the User -->",
    maxItemLength = 100,
    remoteSource,
    minText = 2,
    labelText= 'Linked users'
}) {

    const [users, setUsers] = useState(selected ?? []);
    const [dropdown, setDropdown] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);

    // Sync with parent when selected prop changes
    useEffect(() => {
        setUsers(selected ?? []);
    }, [selected]);

    // Initialize select2 only once
    useEffect(() => {
        if (dropdown && !isInitialized) {
            try {
                dropdown.select2({
                    dropdownParent: dropDownParent ? window.$(`#${dropDownParent}`) : null,
                    ajax: remoteSource ? {
                        transport: async (params, success, failure) => {
                            try {
                                if ((params?.data?.term?.length ?? 0) >= minText) {
                                    const _result = await remoteSource({ text: params?.data?.term });
                                    const _items = _result.map((i) => {
                                        return {
                                            id: i[value],
                                            text: _getText(i),
                                            data: i
                                        }
                                    });
                                    success({ results: _items });
                                } else {
                                    success({ results: [] });
                                }
                            } catch (error) {
                                failure(error);
                            }
                        }
                    } : null
                });

                dropdown.off("change.userlink");
                dropdown.on("change.userlink", (e) => {
                    try {
                        const _data = dropdown.select2('data');
                        if (_data.filter(x => x.data).length) {
                            // Handle new selections from AJAX results
                            const _newSelection = _data.filter(x => x.data).map(x => x.data);
                            // Avoid duplicates by checking if user already exists
                            const filteredNewSelection = _newSelection.filter(newUser => 
                                !users.some(existingUser => existingUser.Id === newUser.Id)
                            );
                            const newusers = users.concat(filteredNewSelection);
                            setUsers(utils.clone(newusers));
                            if (onChange) onChange(newusers);
                        }
                        else {
                            // Handle removals - only keep selected users
                            const _selectedValues = dropdown.find(`:selected`).toArray().map(x => window.$(x).attr("value"));
                            const _newUsers = users.filter(x => _selectedValues.find(y => y == x.Id));
                            setUsers(utils.clone(_newUsers));
                            if (onChange) onChange(_newUsers);
                        }
                    } catch (error) {
                        console.error("Error in select2 change handler:", error);
                    }
                });

                setIsInitialized(true);
            } catch (error) {
                console.error("Error initializing select2:", error);
            }
        }
    }, [dropdown]);

    // Update options when users change
    useEffect(() => {
        if (dropdown && isInitialized) {
            try {
                // Get current options
                const currentOptions = dropdown.find('option').toArray();
                const currentValues = currentOptions.map(opt => window.$(opt).val());
                const newUserIds = users.map(user => user[value]);

                // Remove options that are no longer in users
                currentOptions.forEach(option => {
                    const optionValue = window.$(option).val();
                    if (!newUserIds.includes(optionValue)) {
                        window.$(option).remove();
                    }
                });

                // Add new options for users that don't exist yet
                users.forEach(user => {
                    if (!currentValues.includes(user[value])) {
                        const option = new Option(_getText(user), user[value], true, true);
                        option.setAttribute('data-user-id', user.Id);
                        dropdown.append(option);
                    }
                });

                dropdown.trigger('change.select2');
            } catch (error) {
                console.error("Error updating select2 options:", error);
            }
        }
    }, [users, isInitialized]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (dropdown && dropdown.length > 0) {
                try {
                    dropdown.off("change.userlink");
                    if (dropdown.hasClass("select2-hidden-accessible")) {
                        dropdown.select2('destroy');
                    }
                } catch (error) {
                    console.error("Error cleaning up select2:", error);
                }
            }
        };
    }, [dropdown])



    const _getText = (item, list) => {
        let _text = null;
        if (textDelegate) {
            _text = textDelegate(item);
        } else {
            _text = item[text];
        }


        if (!list && maxItemLength > 0 && _text && _text.length > maxItemLength) {
            _text = `${_text.substring(0, maxItemLength)}...`;
        }

        return _text;
    }



    return ((users) ? (<>
        <label for="task_planned_start_date" className="form-label">{labelText}</label>

        <select ref={(r) => {
            if (r && !dropdown) {
                setDropdown(window.$(r));
            }
        }} class="multi-select select2-groups"
            onChange={(e) => {
                console.log(e);
            }}
            multiple={true}
        >
        </select>

    </>) : <div className="text-center"><img src={waiting} /></div>)
}


export default ActivityUserLink 